
import MdContent from 'components/md-content/md-content.vue'
import SignalActivity from './signal-activity.vue'
import SectionTitle from '../section-title.vue'
import SignalAbout from './signal-about.vue'
import SignalSources from './signal-sources.vue'
import PulseActions from '../pulse-actions.vue'
import SignalBottom from './signal-bottom.vue'

export default {
  components: {MdContent, SignalActivity, SignalSources, SectionTitle, SignalAbout, PulseActions, SignalBottom},
  props: {
    item: {type: Object, required: true},
    tab: {type: String, required: true}
  },
  emits: ['anchor-changed'],
  data(){
    return {
      observer: undefined
    }
  },
  computed: {
    sections () {
      return this.item.sections
    }
  },

  mounted(){
    this.scrollTop(this.tab, false)
  },
  methods: {
    getElement (anchor) {
      const [elem] =  this.$refs[anchor]
      return elem.$el
    },
    unobserveAnchors(){
      if (this.observer) {
        this.observer.unobserveAll()
        this.observer = undefined
      }
    },
    observeAnchors(){
      // if we have observer - we are already subscribed
      if (this.observer) {
        return
      }
      this.observer = this.$refs.scrollbar.getObserver()
      const sections = this.sections
        .filter(s => !!s.anchor)
        .map(s => this.getElement(s.anchor))
      
      sections.push(this.$refs.scroll_bottom)

      this.observer.observeMany(sections, this.observerHandler)
    },
    observerHandler(){
      const elements = this.observer.getAllVisible()
      const bottom = elements.find(el => el === this.$refs.scroll_bottom)  
      // if we are on bottom, we need to unsubscribe observer for preventing double scroll
      // and choose last anchor
      if (bottom) {
        this.unobserveAnchors()
        this.$emit('anchor-changed', this.sections.at(-1).anchor)
        return
      }
      const [el] = elements
      if (!el) return
      const anchor = el.getAttribute('data-anchor')
      if (anchor && anchor !== this.active_tab) {
        this.$emit('anchor-changed', anchor)
      }
    },
    async scrollTop(anchor, smooth = true){
      // when this function is fired from outside - we need to unsubscribe observer for preventing double scroll
      this.unobserveAnchors()
      const element = this.getElement(anchor)
      const margin_top = 12
      let offset = element.offsetTop - margin_top
      if (offset < margin_top) {
        offset = 0
      }
      this.$refs.scrollbar.scrollTop(offset, {smooth, check_bottom: false})
    },
  }
}
